import axios from "axios";
import config from "../../config";
import axiosInstance from "../../utils/axiosInstance";


const BookSuggestionManager = {
  /**
   * Fetch all book suggestions
   * @returns {Promise<Array>} array of BookSuggestDTO
   */
  async getAllSuggestions() {
    const response = await axiosInstance.get(`/suggestions`);
    return response.data.responseData;
  },

  /**
   * Fetch a single book suggestion by ID
   * @param {number|string} id
   * @returns {Promise<Object>} BookSuggestDTO
   */
  async getSuggestionById(id) {
    const response = await axiosInstance.get(`/suggestions/${id}`);
    return response.data.responseData;
  },

  /**
 * Update the status of a suggestion
 * @param {number|string} sugId
 * @param {string} status
 * @returns {Promise<Object>} Updated BookSuggestDTO
 */
async updateSuggestionStatus(sugId, status) {
  const response = await axiosInstance.put(`/suggestions/update-status/${sugId}?status=${status}`);
  return response.data.responseData;
},


  /**
   * Create a new book suggestion
   * @param {Object} suggestionData - fields matching BookSuggestDTO
   * @returns {Promise<Object>} created BookSuggestDTO
   */
  async createSuggestion(suggestionData) {
    const response = await axiosInstance.post(`/suggestions/create`, suggestionData);
    return response.data.responseData;
  },

  /**
   * Delete a book suggestion entry by ID
   * @param {number|string} id
   * @returns {Promise<void>}
   */
  async deleteSuggestion(id) {
    const response = await axiosInstance.delete(`/suggestions/${id}`);
    return response.data;
  },

  async getAllSuggestions() {
    const response = await axiosInstance.get(`/suggestions/all`);
    return response.data.responseData;
  },
};

export default BookSuggestionManager;
